// Read server-owned, per-manager draft AI allowances. Request sequence guards
// keep late responses from a prior event/draft out of the current workspace.
// Failure disables AI actions; manual editing remains available.
import { useCallback, useEffect, useRef, useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase";

export const usePromotionAiUsage = ({ eventId, postId, draftKey, enabled }) => {
  const [usage, setUsage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const sequence = useRef(0);
  const refreshUsage = useCallback(async () => {
    const current = ++sequence.current;
    if (!enabled || (!postId && !draftKey)) {
      setUsage(null); setLoading(false); setError("");
      return;
    }
    setLoading(true); setError("");
    try {
      const result = await httpsCallable(functions, "getPromotionAiUsage")({ eventId: eventId || null, ...(postId ? { postId } : { draftKey }) });
      if (current === sequence.current) setUsage(result.data);
      return result.data;
    } catch (failure) {
      if (current === sequence.current) { setUsage(null); setError(failure.message || "Unable to check remaining AI runs."); }
    } finally {
      if (current === sequence.current) setLoading(false);
    }
  }, [enabled, eventId, postId, draftKey]);
  useEffect(() => {
    refreshUsage();
    return () => { sequence.current += 1; };
  }, [refreshUsage]);
  return { usage, loading, error, refreshUsage };
};
